<template>
  <div>
    <div class="border">
      <selector
        :title="`1. Выберите партнера`"
        :titleKey="`calc_step_1`"
        :prefix="`partner`"
        :modal="`partner`"
        :selectKey="`name`"
        v-model="partner"
      />

      <div v-if="partner && partner.id">
        <fg-input
          :type="`number`"
          :label="`2. Введите стоимость товаров`"
          :labelKey="`calc_step_2`"
          v-model="price"
        ></fg-input>

        <h4 class="text-success">
          {{ "product_price_is" | setText("Стоимость товаров:") }}
          {{ price | spaceBetweenNumber }} UZS
        </h4>

        <h5 v-if="price">{{ "change_period" | setText("ВЫБРИТЕ СРОК") }}</h5>

        <ul class="conditionals" v-if="price">
          <li
            v-for="(conditional, key) in partner.conditionals"
            :key="key"
            @click="setConditional(conditional)"
          >
            <h6
              :class="`badge ${
                cond && conditional.id === cond.id
                  ? 'badge-info'
                  : 'badge-danger'
              }`"
            >
              {{ "choose" | setText("Выбрать") }} {{ conditional.month }}
              {{ "mo" | setText("мес.") }}
            </h6>
            <h6>
              {{
                Math.round(priceCredit(price, conditional) / conditional.month)
                  | spaceBetweenNumber
              }}
              UZS / {{ "mo" | setText("мес.") }}
            </h6>
            <h6>
              {{ priceCredit(price, conditional) | spaceBetweenNumber }}
              UZS
            </h6>
          </li>
        </ul>

        <div v-if="cond">
          <h4>
            {{ "check_limit_on" | setText("Проверка лимита на") }}
            {{ cond.month }} {{ "mo" | setText("мес.") }}
          </h4>
          <h5>
            {{ "paing_during_month_is" | setText("Оплата в месяц:") }}
            {{
              Math.round(priceCredit(price, cond) / cond.month)
                | spaceBetweenNumber
            }}
            UZS / {{ "mo" | setText("мес.") }}
          </h5>
          <h5>
            {{ "price_total" | setText("Общая стоимость") }}:
            {{ priceCredit(price, cond) | spaceBetweenNumber }}
            UZS
          </h5>

          <hr />

          <br />
          <fg-input
            :type="`number`"
            :label="`3. Введите лимит, который выдали клиенту`"
            :labelKey="`calc_step_3`"
            v-model="limit"
          ></fg-input>

          <h4 class="text-info">
            {{ "client_limit_is" | setText("Лимит клиента:") }}
            {{ limit | spaceBetweenNumber }} UZS
          </h4>

          <template v-if="limit">
            <h4 v-if="limitSuccess === true" class="text-success">
              {{ "limit_true" | setText("ЛИМИТ ПРОХОДИТ") }}
            </h4>
            <h4 v-else class="text-danger">
              {{ "limit_false" | setText("ЛИМИТ НЕ ПРОХОДИТ") }}
            </h4>
          </template>

          <template v-if="partner.code === 'iman'">
            <hr />
            <h5>
              {{
                "iman_conditional"
                  | setText(" В заказе НЕ может быть больше 1 девайса")
              }}
            </h5>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cardContent } from "@/plugins/functions";
import { spaceBetweenNumber } from "../../../plugins/filtersTemplate";

export default {
  data: () => ({
    // items: null,
    order: null,
    price: 0,
    partner: null,
    cond: null,
    limit: 0,
    limitForBuy: 0,
    minLimit: 0,
    limitSuccess: false,
  }),
  watch: {
    partner: {
      handler: function (val) {
        this.cond = null;
        this.checkLimit();
      },
      deep: true,
    },
    cond: {
      handler: function (val) {
        this.checkLimit();
      },
      deep: true,
    },
    limit() {
      this.checkLimit();
    },
    price() {
      this.checkLimit();
    },
  },
  props: ["id"],
  async created() {
    // this.items = await this.cardContent(`partners`);
  },
  methods: {
    cardContent: cardContent,
    priceCredit(price, conditional) {
      return Math.round(
        parseInt(price) + (parseInt(price) * conditional.coefficient) / 100
      );
    },
    setConditional(cond) {
      this.cond = cond;
    },
    checkLimit() {
      let limit = parseInt(this.limit);

      this.limitForBuy = limit;

      this.limitSuccess = false;

      if (this.partner && this.cond) {
        //INTEND
        if (this.partner.code === "intend") {
          if (limit >= this.priceCredit(this.price, this.cond)) {
            this.limitSuccess = true;
            return false;
          }
        }
        //PAYMART
        else if (this.partner.code === "paymart") {
          if (limit >= this.price) {
            this.limitSuccess = true;
            return false;
          }
        }
        //IMAN
        else if (this.partner.code === "iman") {
          if (limit >= this.price) {
            this.limitSuccess = true;
            return false;
          }
        }
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
.conditionals {
  & > li {
    cursor: pointer;
    padding: 6px 0;
    border-bottom: 1px solid #ebebeb;

    &:last-child {
      border-bottom: 1px solid #fff;
    }

    display: flex;
    align-items: center;

    & h6 {
      font-size: 12px;
      margin: 0 10px;

      &:last-child {
        margin-left: auto;
      }

      &:first-child {
        margin-right: 100px;
        margin-left: 0;
        min-width: 118px;
      }
    }
  }
}
</style>
